module.exports = __webpack_public_path__ + "img/48.88a38371.svg";